import { render } from "./WithdrawalsPage.vue?vue&type=template&id=0e38ac4c&scoped=true"
import script from "./WithdrawalsPage.vue?vue&type=script&lang=js"
export * from "./WithdrawalsPage.vue?vue&type=script&lang=js"

import "./WithdrawalsPage.vue?vue&type=style&index=0&id=0e38ac4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e38ac4c"]])

export default __exports__